import axiosInstance from "../../../api/axiosConfig";

export const isUserSampleProducts = () => {
  return axiosInstance.get("/user-sample-products/is-sample-products");
};
